import { assert, IGNORED, Test } from "oc-e2e-testrunner";
import {
  asDegree,
  assertSegmentIstLückenlosGefüllt,
  assertWarnungen,
  getInspiredArrangement,
  resetArrangement,
  setSternFormMitWinkelnLeerraumRechts,
  setSternFormMitWinkelnPlain,
} from "./utils";
import { v2 } from "oc-threejs/short3";
import * as Commons from "oc-commons/Commons";
import * as Maths3 from "oc-threejs/Maths3";
import {
  AngleInterval,
  findMatchingRotation,
  getAngleIntervalType,
  intervalIntersection,
  istEckadapter,
  istUMProfil,
  middleAngle,
  normalizeAngle,
  parseAngleIntervalDefinition,
  setPiForTests,
  sortAngleIntervals,
} from "../commons/AngleIntervals";
import { Pfosten } from "../arrangement/Pfosten";
import { UMProfil } from "../arrangement/UMProfil";
import { Strecke2 } from "../arrangement/grundrissFunctions";
import {
  getSollZwischenabstandVerbose,
  getZwischenabstandAnSeiteVerbose,
  LINKS,
  RECHTS,
} from "../arrangement/elementFunctions";

export default {
  name: "TestEckpfosten",
};

const länge = 3;

function initArrangement() {
  const agt = getInspiredArrangement("Inspiration JUMBO WPC Anthrazit");
  return agt;
}

export const testSegmentRichtungKonstant: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.update3d();
  const s = agt.segmente[0];
  const kd1 = s.grundrissKante.direction.clone();
  const sd1 = s.direction.clone();
  agt.update3d();
  const kd2 = s.grundrissKante.direction.clone();
  const sd2 = s.direction.clone();
  assert.deepEquals(kd1, kd2, "GrundrissKante hat eine stabile Direction über Updates");
  assert.deepEquals(sd1, sd2, "Segment hat eine stabile Direction über Updates");
};

export const testEckpfostenHabenKeineNachbarn: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Rechteck", [4, 4]);
  agt.fillIndividuellSegmentsWithElements();
  assert.equals(4, agt.getEckpfosten().length);
  agt.getEckpfosten().forEach((p) => {
    assert.equals(p.nachbarLinks, null);
    assert.equals(p.nachbarRechts, null);
    assert.equals(p.gapLinks, 0);
    assert.equals(p.gapRechts, 0);
  });
};

export const testSingle0Grad: Test = async () => {
  const agt = initArrangement();
  setSternFormMitWinkelnLeerraumRechts(länge, [0]);
  const eckpfosten = agt.getEckpfosten()[0];
  assert.equals(0, eckpfosten.matchingRotation?.angle * asDegree);
};

export const testSingle45Grad: Test = async () => {
  const agt = initArrangement();
  setSternFormMitWinkelnLeerraumRechts(länge, [45]);
  const eckpfosten = agt.getEckpfosten()[0];
  assert.equals(45, eckpfosten.matchingRotation?.angle * asDegree);
};

export const test45GradElemente: Test = async () => {
  const agt = initArrangement();
  setSternFormMitWinkelnLeerraumRechts(länge, [10, 55]);
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(10, eckpfosten.matchingRotation?.angle * asDegree);
};

export const test90GradElemente: Test = async () => {
  const agt = initArrangement();
  setSternFormMitWinkelnLeerraumRechts(länge, [0 + 237.5, -90 + 237.5]);
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(327.5, eckpfosten.matchingRotation?.angle * asDegree);
};

export const testPfostenWinkelWarnung: Test = async () => {
  const agt = initArrangement();
  setSternFormMitWinkelnLeerraumRechts(länge, [0, 20]);
  assertWarnungen(agt, ["Für diesen Winkel passt der Pfosten nicht"]);
};

export const testPfostenOrientierungNachElementen: Test = async () => {
  const agt = initArrangement();
  setSternFormMitWinkelnLeerraumRechts(länge, [45, 135]);
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(45, eckpfosten.matchingRotation?.angle * asDegree);
};

export const testKeinEckadapterWennKeinElementAnliegtSpezielleSituation: Test = async () => {
  const agt = initArrangement();
  const angles = [0, 45, 90, 135, 180];
  setSternFormMitWinkelnLeerraumRechts(
    5,
    angles.map((w) => w + 10)
  );
  agt.update3d();
  // agt.segmente[1].verteilungsstrategieAuswahlwert =
  //   APP.richMetadata.findAuswahlwert("LeerraumRechts");
  // agt.update3d();
  // assertWarnungen(agt, []);
  // const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  // assert.isNotNull(eckpfosten.matchingRotation);
  // assert.deepEquals(
  //   [0, 90, 135, 180],
  //   eckpfosten.angles.map((e) => e.angle * asDegree - 10)
  // );
  // assert.deepEquals(
  //   [false, false, false, true, false],
  //   agt.segmente.map((s) => s.eckadapter.length > 0)
  // );
};

export const testPfostenDrehtSoDassVieleElementeAnFlacherSeiteAnliegen1: Test = async () => {
  const agt = initArrangement();
  const angles = [0 * 90, 1 * 45, 1 * 90, 3 * 45, 2 * 90];
  setSternFormMitWinkelnLeerraumRechts(
    5,
    angles.map((w) => w + 10)
  );
  agt.update3d();
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.isNotNull(eckpfosten.matchingRotation, "matchingRotation");
  assertWarnungen(agt, []);
  assert.equals(10, eckpfosten.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [false, true, false, true, false],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
};

export const testPfostenDrehtSoDassVieleElementeAnFlacherSeiteAnliegen2: Test = async () => {
  const agt = initArrangement();
  const angles = [0, 90, 135, 180];
  setSternFormMitWinkelnLeerraumRechts(5, angles);
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.isNotNull(eckpfosten.matchingRotation);
  assert.equals(0, eckpfosten.matchingRotation?.angle * asDegree);
  assert.isTrue(!istEckadapter(getAngleIntervalType(eckpfosten, (0 * Math.PI) / 180)));
  assert.isTrue(!istEckadapter(getAngleIntervalType(eckpfosten, (90 * Math.PI) / 180)));
  assert.isFalse(!istEckadapter(getAngleIntervalType(eckpfosten, (135 * Math.PI) / 180)));
  assert.isTrue(!istEckadapter(getAngleIntervalType(eckpfosten, (180 * Math.PI) / 180)));
  assert.deepEquals(
    [false, false, true, false],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
};

export const testPfostenDrehtSoDassVieleElementeAnFlacherSeiteAnliegen3: Test = async () => {
  const agt = initArrangement();
  setSternFormMitWinkelnLeerraumRechts(5, [90, 0, 180]);
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.isNotNull(eckpfosten.matchingRotation);
  assert.equals(0, eckpfosten.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [false, false, false],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
};

export const testPfostenDrehtSoDassVieleElementeAnFlacherSeiteAnliegen4: Test = async () => {
  const agt = initArrangement();
  setSternFormMitWinkelnLeerraumRechts(
    länge,
    [0 * 90, 1 * 45, 1 * 90, 5 * 45].map((w) => w + 120)
  );
  agt.update3d();
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  // assert.equals(135, (eckpfosten.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [true, false, true, false],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
};

export const testPfosten0Und135: Test = async () => {
  const agt = initArrangement();
  setSternFormMitWinkelnLeerraumRechts(länge, [0, 135]);
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(0, eckpfosten.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [false, true],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
};

export const testPfosten0Und138: Test = async () => {
  const agt = initArrangement();
  setSternFormMitWinkelnLeerraumRechts(länge, [0, 138]);
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(1.5, eckpfosten.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [false, true],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
};

export const testPfosten180Und48: Test = async () => {
  const agt = initArrangement();
  setSternFormMitWinkelnLeerraumRechts(länge, [180, 48]);
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(1.5, eckpfosten.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [false, true],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
};

export const testPfosten180Und116: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC XL Sand");
  setSternFormMitWinkelnLeerraumRechts(länge, [180, 116]);
  assertWarnungen(agt, []);
  assert.deepEquals(
    [true, true],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
};

export const testIntervalIntersection: Test = async () => {
  const intersection = (a: number[], b: number[]) => {
    const [aa, bb] = [a, b].map((i) => i.map((x) => x / asDegree));
    const r = intervalIntersection(aa, bb);
    return r ? r.map((x) => x * asDegree) : null;
  };
  assert.deepEquals([1, 2], intersection([0, 359.99], [1, 2]));
  assert.deepEquals([1, 1], intersection([0, 1], [1, 2]));
  assert.deepEquals([1, 2], intersection([0, 2], [1, 2]));
  assert.deepEquals([0, 1], intersection([0, 2], [0, 1]));
  assert.deepEquals([1, 2], intersection([0, 2], [1, 3]));
  assert.deepEquals([1, 2], intersection([0, 3], [1, 2]));
  assert.deepEquals([2, 3], intersection([2, 4], [1, 3]));
  assert.deepEquals([359, 1], intersection([-2, 1], [-1, 2]));
  assert.deepEquals([0, 0], intersection([350, 360], [0, 10]));
};

export const testFindMatchingRotation: Test = async () => {
  // Falls man in diesen Tests unklarheiten hat, hilft es, sich einen Kreis mit Gradeinteilungen als
  // image zu suchen und in einem Zeichenprogramm wie "Google Zeichnungen" Winkel und Intervalle
  // drüberzuzeichnen und zu rotieren

  // Für diesen Test wird die interne Verarbeitung des getesteten Codes in Grad gesetzt, was wesentlich
  // einfacher zu debuggen ist als in Rad.
  setPiForTests(180);

  const findRotation = (intervals: AngleInterval[], angels: number[]) =>
    findMatchingRotation(
      sortAngleIntervals(intervals.map(([a, b, c]) => [normalizeAngle(a), normalizeAngle(b), c])),
      angels.map((a) => ({ angle: normalizeAngle(a), flacheSeiteNotwendig: false, element: null }))
    )?.angle;

  try {
    const intervals = parseAngleIntervalDefinition(
      "0°, 42-48°E, 90°, 132-138°E, 180°, 222-228°E, 270°, 312-318°E",
      0.5
    );

    assert.deepEquals(
      [
        [359.75, 0.25, null],
        [42, 48, "E"],
        [89.75, 90.25, null],
        [132, 138, "E"],
        [179.75, 180.25, null],
        [222, 228, "E"],
        [269.75, 270.25, null],
        [312, 318, "E"],
      ],
      intervals
    );

    assert.equals(0, findRotation([], []));
    assert.isNull(findRotation([], [0]));
    assert.isNull(findRotation([[0, 0, null]], [0, 1]));
    assert.equals(0, findRotation([[0, 0, null]], [0]));
    assert.equals(0, findRotation([[-1, 1, null]], [0]));
    assert.equals(359, findRotation([[0, 2, null]], [0]));
    assert.equals(90, findRotation([[0, 0, "E"]], [90]));
    assert.equals(0, findRotation([[90, 90, "E"]], [90]));

    assert.equals(0, findRotation(intervals, [0]));

    assert.equals(0, findRotation(intervals, [0, 180]));

    assert.equals(
      100,
      findRotation(
        [
          [-120, -80, null],
          [80, +120, null],
        ],
        [0]
      )
    );
    assert.equals(
      0,
      findRotation(
        [
          [-100, -80, null],
          [80, +100, null],
        ],
        [-90, +90]
      )
    );
    assert.equals(
      0,
      findRotation(
        [
          [80, 120, null],
          [240, 280, null],
        ],
        [90, 270]
      )
    );
    assert.equals(
      180,
      findRotation(
        [
          [-120, -80, null],
          [80, +120, null],
        ],
        [-80, +80]
      )
    );
    assert.equals(
      0,
      findRotation(
        [
          [-120, -80, null],
          [80, +120, null],
        ],
        [-120, +120]
      )
    );
    assert.equals(
      180,
      findRotation(
        [
          [-120, -80, null],
          [80, +120, null],
        ],
        [-70, +70]
      )
    );
    assert.isNull(
      findRotation(
        [
          [-120, -80, null],
          [80, +120, null],
        ],
        [-130, +130]
      )
    );

    assert.equals(
      180,
      findRotation(
        [
          [60, 100, null],
          [260, 300, null],
        ],
        [100, 260]
      )
    );
    assert.equals(
      20,
      findRotation(
        [
          [60, 100, null],
          [260, 300, null],
        ],
        [100, 300]
      )
    );
    assert.equals(
      330,
      findRotation(
        [
          [60, 100, null],
          [260, 300, null],
        ],
        [50, 250]
      )
    );

    assert.equals(
      0,
      findRotation(
        [
          [-120, 0, null],
          [0, +120, null],
        ],
        [-90, +90]
      )
    );
    assert.equals(
      180,
      findRotation(
        [
          [0, 120, null],
          [240, 360, null],
        ],
        [120, 240]
      )
    );

    assert.equals(10, findRotation(intervals, [145, 190]));

    assert.equals(0, findRotation(intervals, [135, 180]));
    assert.equals(1.375, findRotation(intervals, [135 + 3, 180 - 0.25]));

    assert.equals(0, findRotation(intervals, [0, 45, 90]));
    assert.equals(0, findRotation(intervals, [0, 45, 90, 135]));
    assert.isNull(findRotation(intervals, [30, 90, 102, 180]));
    assert.equals(30, findRotation(intervals, [30]));
    assert.equals(
      5,
      findRotation(
        intervals,
        intervals.map((i) => middleAngle(i[0], i[1]) + 5)
      )
    );
    assert.isNull(findRotation(intervals, [1, 2]));
    assert.equals(0, findRotation(intervals, _.range(0, 360, 360 / 2)));
    assert.isNull(findRotation(intervals, _.range(0, 360, 360 / 3)));
    assert.equals(0, findRotation(intervals, _.range(0, 360, 360 / 4)));

    assert.equals(0, findRotation(intervals, [0, 90, 135, 180]));

    assert.equals(
      75,
      findRotation(
        [
          [0, 45, null],
          [135, 180, null],
        ],
        [120, 210]
      )
    );
  } finally {
    setPiForTests(Math.PI);
  }
};

export const testFindMatchingRotation2: Test = async () => {
  // Falls man in diesen Tests unklarheiten hat, hilft es, sich einen Kreis mit Gradeinteilungen als
  // image zu suchen und in einem Zeichenprogramm wie "Google Zeichnungen" Winkel und Intervalle
  // drüberzuzeichnen und zu rotieren

  // Für diesen Test wird die interne Verarbeitung des getesteten Codes in Grad gesetzt, was wesentlich
  // einfacher zu debuggen ist als in Rad.
  setPiForTests(180);

  const findRotation = (intervals: AngleInterval[], angels: number[]) =>
    findMatchingRotation(
      sortAngleIntervals(intervals.map(([a, b, c]) => [normalizeAngle(a), normalizeAngle(b), c])),
      angels.map((a) => ({ angle: normalizeAngle(a), flacheSeiteNotwendig: false, element: null }))
    )?.angle;

  try {
    const intervals = parseAngleIntervalDefinition(
      "0°, 30°-60°E, 90°, 120°-150°E, 180°, 210°-240°E, 270°, 300°-330°E",
      0.5
    );
    assert.equals(
      10,
      findRotation(
        intervals,
        [
          10.00000000003249, 55.00000000017869, 100.0000000003249, 145.0000000004711,
          190.0000000006173,
        ]
      )
    );
  } finally {
    setPiForTests(Math.PI);
  }
};

export const testEckadapterJedeEcke: Test = async () => {
  const agt = initArrangement();
  setSternFormMitWinkelnLeerraumRechts(länge, _.range(0, 360, 45));
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(0, eckpfosten.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [false, true, false, true, false, true, false, true],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
  assert.isTrue(
    agt.segmente.every(
      (s) => s.getElemente()[0].umprofilLinks == null && s.getElemente()[0].umprofilRechts == null
    )
  );
};

export const test45GradElementeAnKlemmpfosten: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  setSternFormMitWinkelnLeerraumRechts(länge, [0, 45]);
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(0, eckpfosten.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [false, true],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
};

export const test2EckenMitKlemmpfosten: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  setSternFormMitWinkelnLeerraumRechts(länge, [0, 45, 90, 135, 225, 315]);
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(
    "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm als Eckpfosten",
    eckpfosten.meta.Key
  );
  assert.equals(45, eckpfosten.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [true, false, true, false, false, false],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
  assert.deepEquals(
    [true, false, true, false, false, false],
    agt.segmente.map(
      (s) =>
        s.getElemente()[0].eckadapterLinks != null || s.getElemente()[0].eckadapterRechts != null
    )
  );
  assert.deepEquals(
    [0.0617, 0.045, 0.0617, 0.045, 0.045, 0.045],
    agt.segmente.map((s) =>
      s.ecken[0] == eckpfosten.ecke
        ? s.getX(s.getElemente()[0], 0)
        : s.breite - s.getX(s.getElemente()[0], 1)
    )
  );
};

export const testAlleEckenMitKlemmpfosten: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  setSternFormMitWinkelnLeerraumRechts(länge, _.range(0, 360, 45));
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(
    "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm als Eckpfosten",
    eckpfosten.meta.Key
  );
  assert.equals(0, eckpfosten.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [false, true, false, true, false, true, false, true],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
  assert.deepEquals(
    [false, true, false, true, false, true, false, true],
    agt.segmente.map(
      (s) =>
        s.getElemente()[0].eckadapterLinks != null || s.getElemente()[0].eckadapterRechts != null
    )
  );
  assert.deepEquals(
    [0.045, 0.0617, 0.045, 0.06171200017184075, 0.045, 0.0617, 0.045, 0.0617120001718402],
    agt.segmente.map((s) =>
      s.ecken[0] == eckpfosten.ecke
        ? s.getX(s.getElemente()[0], 0)
        : s.breite - s.getX(s.getElemente()[0], 1)
    )
  );
  assert.deepEquals(
    [true, true, true, true, true, true, true, true],
    agt.segmente.map(
      (s) => s.getElemente()[0].umprofilLinks != null || s.getElemente()[0].umprofilRechts != null
    )
  );
};

export const test135GradElementeAnKlemmpfostenUndFixeElemente: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  setSternFormMitWinkelnLeerraumRechts(länge, [0, 135, 270]);
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(0, eckpfosten.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [false, true, false],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
};

export const testSteckpfostenRotationUndMaßelemente1: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  setSternFormMitWinkelnLeerraumRechts(länge, [0, 135]);
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.segmente.forEach((s) => (s.verteilungsstrategieAuswahlwert_ = null));
  agt.update3d();
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals("2140 SYSTEM Eck-Steckpfosten Anthrazit  Erdverbau 240 cm", eckpfosten.meta.Key);
  assert.deepEquals(
    [false, false],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
  assert.equals(337.5, eckpfosten.matchingRotation?.angle * asDegree);
  assertWarnungen(agt, []);
};

export const testSteckpfostenRotationUndMaßelemente2: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  setSternFormMitWinkelnLeerraumRechts(länge, [0, 100]);
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.segmente.forEach((s) => (s.verteilungsstrategieAuswahlwert_ = null));
  agt.update3d();
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals("2140 SYSTEM Eck-Steckpfosten Anthrazit  Erdverbau 240 cm", eckpfosten.meta.Key);
  assert.deepEquals(
    [false, false],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
  assert.equals(320, eckpfosten.matchingRotation?.angle * asDegree);
  assertWarnungen(agt, []);
};

export const testSteckpfostenRotationUndMaßelemente3: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  setSternFormMitWinkelnLeerraumRechts(länge, [291, 200]);
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.segmente.forEach((s) => (s.verteilungsstrategieAuswahlwert_ = null));
  agt.update3d();
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals("2140 SYSTEM Eck-Steckpfosten Anthrazit  Erdverbau 240 cm", eckpfosten.meta.Key);
  assert.deepEquals(
    [false, false],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
  assert.equals(155.5, eckpfosten.matchingRotation?.angle * asDegree);
  assertWarnungen(agt, []);
};

export const testSteckpfostenRotationUndMaßelemente4: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  setSternFormMitWinkelnLeerraumRechts(1, [0, 135]);
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.segmente.forEach((s) => (s.verteilungsstrategieAuswahlwert_ = null));
  agt.update3d();
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals("2140 SYSTEM Eck-Steckpfosten Anthrazit  Erdverbau 240 cm", eckpfosten.meta.Key);
  assert.deepEquals(
    [false, false],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
  assert.equals(337.5, eckpfosten.matchingRotation?.angle * asDegree);
  assertWarnungen(agt, []);
};

export const testEckadapterUndMasselement: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  setSternFormMitWinkelnLeerraumRechts(länge, [0, 135, 270]);
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.segmente.forEach((s) => (s.verteilungsstrategieAuswahlwert_ = null));
  agt.update3d();
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(0, eckpfosten.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [false, true, false],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
  assertWarnungen(agt, []);
};

export const testEckeMitDivergenterEndlosschleifeOhneWarnungen: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.grundriss.setStrecken([[v2(0, 0), v2(8, 0)]]);
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("LeerraumRechts");
  agt.update3d();
  const pfosten = agt.getPfosten()[3];
  const position = Maths3.v3To2xz(pfosten.getWorldPosition());
  agt.grundriss.setStrecken([...agt.grundriss.getStrecken(), [position, v2(-2, -2).add(position)]]);
  try {
    // agt.THROW_ERROR_ON_DIVERGENT_UPDATES = true;
    // Hier wird der Error geworfen. Was komisch ist:
    // Der Algorithmus behandelt
    agt.update3d();

    agt.MAX_UPDATE_CYCLES = 10;
    agt.THROW_ERROR_ON_DIVERGENT_UPDATES = true;
    const grundrissJSON = agt.grundriss.toJSON();
    agt.update3d();
    // APP.__logit = true;
    // assert.deepEquals(grundrissJSON, agt.grundriss.toJSON());
    // agt.update3d();
    assertWarnungen(agt, []);
    // agt.update3d();
    // assertWarnungen(agt, []);
  } finally {
    agt.THROW_ERROR_ON_DIVERGENT_UPDATES = false;
    // agt.MAX_UPDATE_CYCLES = 10;
  }
};

export const testEckeInnen: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.grundriss.setStrecken([[v2(0, 0), v2(8, 0)]]);
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("LeerraumRechts");
  agt.update3d();
  const pfosten = agt.getPfosten()[3];
  const position = Maths3.v3To2xz(pfosten.getWorldPosition());
  agt.grundriss.setStrecken([...agt.grundriss.getStrecken(), [position, v2(-2, -2).add(position)]]);
  agt.update3d();
  agt.update3d();
  agt.segmente[0].verteilungsstrategieAuswahlwert =
    APP.richMetadata.findAuswahlwert("LeerraumLinks");
  const getSegmentIds = () => agt.segmente.map((s) => s.id);
  const segmentIds = getSegmentIds();
  assert.deepEquals(
    ["LeerraumLinks", "LeerraumRechts", "LeerraumRechts"],
    agt.segmente.map((s) => s.verteilungsstrategieAuswahlwert.Key)
  );
  const grundrissJSON = agt.grundriss.toJSON();
  agt.update3d();
  assert.deepEquals(grundrissJSON, agt.grundriss.toJSON());
  assert.deepEquals(segmentIds, getSegmentIds());
  assert.deepEquals(
    ["LeerraumLinks", "LeerraumRechts", "LeerraumRechts"],
    agt.segmente.map((s) => s.verteilungsstrategieAuswahlwert.Key)
  );
  const eckpfosten = agt.getPfosten().find((p) => p.angles.length > 2);
  assert.equals(
    "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm als Eckpfosten",
    eckpfosten.meta.Key
  );
  assert.isNotNull(eckpfosten.ecke);
  assert.equals(0, eckpfosten.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [180, 225, 0],
    eckpfosten.angles.map((pa) => normalizeAngle(pa.angle) * asDegree)
  );
  assert.deepEquals(
    [false, true, false],
    eckpfosten.angles.map((pa) => istEckadapter(getAngleIntervalType(eckpfosten, pa.angle)))
  );
  assert.deepEquals(
    [null, "Eckadapter 135 oder 45 Anthrazit 192 cm", null],
    eckpfosten.angles.map((pa) => pa.element.eckadapterLinks?.meta?.Key)
  );
  assertWarnungen(agt, []);
};

export const testDoppeltorMitEckadapter1: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  setSternFormMitWinkelnLeerraumRechts(3, [0, 135]);
  let eckpfosten = agt.getEckpfosten().find((e) => e.elemente.length > 1);
  const doppeltor = eckpfosten.elemente[1];
  agt.setSelectedObjects([doppeltor]);
  agt.update3d();
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Doppeltor_Easy");
  const füllungAuswahlwert = doppeltor.füllungAuswahlwert;
  agt.changeSelectedZaunElemente({
    massAuswahlwert,
    füllungAuswahlwert,
  });
  doppeltor.behalteLichteweite(
    () => (doppeltor.eAntriebAuswahlwert = APP.richMetadata.findAuswahlwert("E_Antrieb_ohne"))
  );
  agt.update3d();
  agt.setSelectedObjects([]);
  agt.update3d();
  eckpfosten = agt.getEckpfosten().find((e) => e.elemente.length > 1);
  assert.isNotNull(eckpfosten, "Eckpfosten");
  assert.equals("E1080 Torpfosten einbetonieren 180 anthrazit Aufhängeseite", eckpfosten.meta.Key);
  assert.isNotNull(eckpfosten.ecke);
  assert.equals(315, eckpfosten.matchingRotation?.angle * asDegree);
  assert.isTrue(!istEckadapter(getAngleIntervalType(eckpfosten, doppeltor.segment.angle)));
  const anderesElement = eckpfosten.elemente.find((e) => e !== doppeltor);
  assert.isFalse(!istEckadapter(getAngleIntervalType(eckpfosten, anderesElement.segment.angle)));
  assert.equals(0, doppeltor.segment.eckadapter.length);
  assert.equals(1, anderesElement.segment.eckadapter.length);
  assert.isNotNull(anderesElement.eckadapterLinks);
  assert.isNotNull(anderesElement.umprofilLinks);
  assertWarnungen(agt, [
    "Torflügel kollidiert im Öffnungsbereich mit anderen Elementen",
    "Dieses Teil kollidiert mit dem Öffnungsbereich eines Torflügels",
  ]);

  // Wenn es ein Tor ist, dann muss es als High Priority gelten..
};

// Bug hier: eine nicht-Individuell-Verteilungsstrategie macht aus beiden Torpfosten einen Eckpfosten.
// Bei einer Individuell-Verteilungsstrategie wird dagegen einer der Torpfosten nicht als Eckpfosten gemacht - eben wohl weil zu klein.
// Das automatische Einfügen des Doppeltores macht das Tor dann wie bei der Individuell-Verteilungsstrategie etwas zu klein!
// Tore selbst sind ausserdem aus der Verteilungsstrategie ausgenommen. Diese würde Segmentabschnitte ohne Tore mit Elementen auffüllen.
// Allerdings passt hier kein Element mehr rein, der Leerraum ist zu klein.
// Sollte sich das Tor dann von der Größe her anpassen?
export const testDoppeltorMitEckadapter2: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  setSternFormMitWinkelnLeerraumRechts(3, [0, 135]);
  let eckpfosten = agt.getEckpfosten().find((e) => e.elemente.length > 1);
  const doppeltor = eckpfosten.elemente[0];
  agt.setSelectedObjects([doppeltor]);
  agt.update3d();
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Doppeltor_Easy");
  doppeltor.behalteLichteweite(
    () => (doppeltor.eAntriebAuswahlwert = APP.richMetadata.findAuswahlwert("E_Antrieb_ohne"))
  );
  const füllungAuswahlwert = doppeltor.füllungAuswahlwert;
  agt.changeSelectedZaunElemente({
    massAuswahlwert,
    füllungAuswahlwert,
  });
  agt.update3d();
  agt.setSelectedObjects([]);
  agt.update3d();
  eckpfosten = agt.getEckpfosten().find((e) => e.elemente.length > 1);
  assert.isNotNull(eckpfosten, "Eckpfosten");
  assert.equals("E1080 Torpfosten einbetonieren 180 anthrazit Aufhängeseite", eckpfosten.meta.Key);
  assert.isNotNull(eckpfosten.ecke);
  assert.equals(0, eckpfosten.matchingRotation?.angle * asDegree);
  assert.isTrue(!istEckadapter(getAngleIntervalType(eckpfosten, doppeltor.segment.angle)));
  const anderesElement = eckpfosten.elemente.find((e) => e !== doppeltor);
  assert.isFalse(!istEckadapter(getAngleIntervalType(eckpfosten, anderesElement.segment.angle)));
  assert.equals(0, doppeltor.segment.eckadapter.length);
  assert.equals(1, anderesElement.segment.eckadapter.length);
  assert.isNotNull(anderesElement.eckadapterLinks);
  assert.isNotNull(anderesElement.umprofilLinks);
  assert.deepEquals(
    [
      "E1080 Torpfosten einbetonieren 180 anthrazit Aufhängeseite",
      "E1080 Torpfosten einbetonieren 180 anthrazit Aufhängeseite",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
    ],
    APP.arrangement.getPfosten().map((p) => p.meta?.Key)
  );
  assertWarnungen(agt, []);
};

export const testFreistehendesEinzeltorGleichmässig: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  setSternFormMitWinkelnLeerraumRechts(1.5, [0]);
  agt.segmente[0].verteilungsstrategieAuswahlwert_ =
    APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.update3d();
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  const einzeltor = agt.getElemente()[0];
  agt.setSelectedObjects([einzeltor]);
  const füllungAuswahlwert = einzeltor.füllungAuswahlwert;
  agt.changeSelectedZaunElemente({
    massAuswahlwert,
    füllungAuswahlwert,
  });
  einzeltor.behalteLichteweite(
    () => (einzeltor.eAntriebAuswahlwert = APP.richMetadata.findAuswahlwert("E_Antrieb_ohne"))
  );
  assert.equals("Individuell", einzeltor.segment.verteilungsstrategieAuswahlwert_.Key);
  einzeltor.segment.verteilungsstrategieAuswahlwert_ =
    APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.update3d();
  assert.deepEquals(
    [
      "E1082 Torpfosten einbetonieren 180 anthrazit Schlossseite",
      "E1080 Torpfosten einbetonieren 180 anthrazit Aufhängeseite",
    ],
    APP.arrangement.getPfosten().map((p) => p.meta?.Key)
  );
  assertWarnungen(agt, []);
};

export const testEinzeltorInBreitemZaunGleichmässig: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  setSternFormMitWinkelnLeerraumRechts(12, [0]);
  agt.segmente[0].verteilungsstrategieAuswahlwert_ =
    APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.update3d();
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  const einzeltor = agt.getElemente()[3];
  const füllungAuswahlwert = einzeltor.füllungAuswahlwert;
  agt.setSelectedObjects([einzeltor]);
  agt.changeSelectedZaunElemente({
    massAuswahlwert,
    füllungAuswahlwert,
  });
  assert.equals("Individuell", einzeltor.segment.verteilungsstrategieAuswahlwert_.Key);
  einzeltor.segment.verteilungsstrategieAuswahlwert_ =
    APP.richMetadata.findAuswahlwert("Gleichmässig");
  einzeltor.behalteLichteweite(
    () => (einzeltor.eAntriebAuswahlwert = APP.richMetadata.findAuswahlwert("E_Antrieb_ohne"))
  );
  agt.update3d();
  assert.deepEquals(
    [
      "E1082 Torpfosten einbetonieren 180 anthrazit Schlossseite",
      "E1080 Torpfosten einbetonieren 180 anthrazit Aufhängeseite",
    ],
    APP.arrangement.getTorpfosten().map((p) => p.meta?.Key)
  );
  assertWarnungen(agt, []);
};

export const testElementhalter: Test = async () => {
  const agt = getInspiredArrangement("Inspiration XL Holzzaun");
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("LeerraumLinks");
  setSternFormMitWinkelnLeerraumRechts(3, [0, 135]);
  assert.equals(12, agt.getElemente().flatMap((e) => e.elementhalter).length);
};

export const testPfostenMitUMProfilenNurAnSpeziellenWinkeln: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("LeerraumLinks");
  setSternFormMitWinkelnLeerraumRechts(3, [0, 90, 180]);
  const eckpfosten = agt.getEckpfosten()[0];
  assert.deepEqualsPicked(
    {
      Key: "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      Winkelbereiche: "0°, 90°U, 180°, 270°U",
    },
    eckpfosten.meta
  );
  assert.deepEquals(
    [false, false, false],
    agt.segmente.map((s) => istEckadapter(getAngleIntervalType(eckpfosten, s.angle))),
    "istEckadapter"
  );
  assert.deepEquals(
    [false, true, false],
    agt.segmente.map((s) => istUMProfil(getAngleIntervalType(eckpfosten, s.angle))),
    "istUMProfil"
  );
  assert.deepEquals(
    [
      [null, null],
      ["2777 SYSTEM U-Klemmprofil Anthrazit 192 cm", null],
      [null, null],
    ],
    agt.segmente.map((s) => {
      const e = s.getElemente()[0];
      const umprofile = [e.umprofilLinks, e.umprofilRechts].map((u) => u?.meta?.Key);
      return e.pfostenLinks === eckpfosten ? umprofile : umprofile.toReversed();
    }),
    "tatsächliches UMProfil"
  );
};

export const testEckpfosten90GradwirdGegenüberPfostenMitUMProfilenBevorzugt: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("LeerraumLinks");
  setSternFormMitWinkelnLeerraumRechts(3, [0, 90]);
  const eckpfosten = agt.getEckpfosten()[0];
  assert.deepEqualsPicked(
    {
      Key: "2342 SYSTEM Eck-Klemmpfosten Anthrazit 192 cm | einbetoniert",
      Winkelbereiche: "270°, 0°",
    },
    eckpfosten.meta
  );
  assert.deepEquals(
    [false, false],
    agt.segmente.map((s) => istEckadapter(getAngleIntervalType(eckpfosten, s.angle))),
    "istEckadapter"
  );
  assert.deepEquals(
    [
      [null, null],
      [null, null],
    ],
    agt.segmente.map((s) => {
      const e = s.getElemente()[0];
      const umprofile = [e.umprofilLinks, e.umprofilRechts].map((u) => u?.meta?.Key);
      return e.pfostenLinks === eckpfosten ? umprofile : umprofile.toReversed();
    }),
    "tatsächliches UMProfil"
  );
};

export const testRivaEckadapter: Test = async () => {
  const agt = getInspiredArrangement("Inspiration Longlife Riva Weiss");
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("LeerraumLinks");
  setSternFormMitWinkelnLeerraumRechts(3, [0, 45]);
  assert.equals(12, agt.getElemente().flatMap((e) => e.elementhalter).length);
  assertWarnungen(agt, []);
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals("0771 LONGLIFE Pfosten Weiß 240 cm", eckpfosten.meta.Key);
  assert.equals(0, eckpfosten.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [false, true],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
};

export const testRechteckKlemmpfosten: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Klemmpfosten");
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.grundriss.setStandardForm("Rechteck", [3, 3]);
  const angle = 60 / asDegree;
  const strecken = agt.grundriss.getStrecken();
  strecken.forEach((strecke) => {
    strecke.forEach((a) => a.rotateAround(v2(), angle));
  });
  agt.grundriss.setStrecken(strecken);
  agt.update3d();
  agt.getElemente().forEach((e) => (e.visible = false));
  agt.update3d();
  assert.deepEquals(
    [
      "2342 SYSTEM Eck-Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2342 SYSTEM Eck-Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2342 SYSTEM Eck-Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2342 SYSTEM Eck-Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
    ],
    agt.getPfosten().map((e) => e.meta.Key)
  );
};

export const testRechteckSteckpfosten: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.grundriss.setStandardForm("Rechteck", [3, 3]);
  const angle = 60 / asDegree;
  agt.grundriss.setStrecken(
    agt.grundriss
      .getStrecken()
      .map((strecke) => strecke.map((a) => a.rotateAround(v2(), angle)) as Strecke2)
  );
  agt.update3d();
  agt.getElemente().forEach((e) => (e.visible = false));
  agt.update3d();
  assert.deepEquals(
    [
      "2140 SYSTEM Eck-Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2140 SYSTEM Eck-Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2140 SYSTEM Eck-Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2140 SYSTEM Eck-Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
    ],
    agt.getPfosten().map((e) => e.meta.Key)
  );
};

export const test135GradMasselementSteckpfosten: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  setSternFormMitWinkelnLeerraumRechts(1, [0, 135]);
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.segmente.forEach((s) => (s.verteilungsstrategieAuswahlwert_ = null));
  agt.update3d();
  assert.deepEquals(
    [
      "2140 SYSTEM Eck-Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
    ],
    agt.getPfosten().map((p) => p.meta.Key)
  );
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(
    0,
    agt.getPfosten().findIndex((e) => e === eckpfosten)
  );
  assert.deepEquals(
    [false, false],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
  assert.equals(0, agt.getPartsAndPfosten().filter((e) => e.isUMProfil).length, "Anzahl UMProfile");
  assert.equals(337.5, eckpfosten.matchingRotation?.angle * asDegree);
  assertWarnungen(agt, []);
};

export const test135GradMasselementKlemmpfosten: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Klemmpfosten");
  setSternFormMitWinkelnLeerraumRechts(1, [0, 135]);
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.segmente.forEach((s) => (s.verteilungsstrategieAuswahlwert_ = null));
  agt.update3d();
  assert.deepEquals(
    [
      "2140 SYSTEM Eck-Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
      "2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert",
    ],
    agt.getPfosten().map((p) => p.meta.Key)
  );
  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(
    0,
    agt.getPfosten().findIndex((e) => e === eckpfosten)
  );
  const pfosten = agt.getPfosten();
  assert.equals("", getAngleIntervalType(pfosten[0], agt.segmente[0].angle));
  assert.equals("", getAngleIntervalType(pfosten[2], agt.segmente[1].angle));
  assert.deepEquals(
    [false, false],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
  assert.equals(0, agt.getPartsAndPfosten().filter((e) => e.isUMProfil).length, "Anzahl UMProfile");
  assert.equals(337.5, eckpfosten.matchingRotation?.angle * asDegree);
  assertWarnungen(agt, []);
};

export const test135GradMasselementMetallpfosten: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Metallpfosten");
  setSternFormMitWinkelnLeerraumRechts(1, [0, 135]);
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.segmente.forEach((s) => (s.verteilungsstrategieAuswahlwert_ = null));
  agt.update3d();
  assert.deepEquals(
    [
      "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm als Eckpfosten",
      "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm",
      "1590 Metallpfosten Anthrazit Erdverbau 7 x 7 x 240 cm",
    ],
    agt.getPfosten().map((p) => p.meta.Key)
  );

  const element = agt.eckadapter[0].segment.getElemente()[0];
  const soll = [LINKS, RECHTS].map((richtung) =>
    getSollZwischenabstandVerbose(element, element.meta, richtung)
  );
  const ist = [LINKS, RECHTS].map((richtung) =>
    getZwischenabstandAnSeiteVerbose(element, richtung)
  );
  assert.deepEqualsPicked(
    soll,
    ist,
    "assert.deepEquals(soll,ist) failed: rot=SOLL getSollZwischenabstandVerbose, grün=IST getZwischenabstandAnSeiteVerbose"
  );

  const eckpfosten = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.equals(
    0,
    agt.getPfosten().findIndex((e) => e === eckpfosten)
  );
  assert.deepEquals(
    [false, true],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
  assert.equals(4, agt.getPartsAndPfosten().filter((e) => e.isUMProfil).length, "Anzahl UMProfile");
  assert.equals(0, eckpfosten.matchingRotation?.angle * asDegree);
  assertWarnungen(agt, []);
};

export const testMasselementSteckpfosten1m: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  setSternFormMitWinkelnLeerraumRechts(1, [0]);
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.segmente.forEach((s) => (s.verteilungsstrategieAuswahlwert_ = null));
  agt.update3d();
  assert.deepEquals(
    [
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
    ],
    agt.getPfosten().map((p) => p.meta.Key)
  );
  assertWarnungen(agt, []);
};

export const testMasselementSteckpfosten2m: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  setSternFormMitWinkelnLeerraumRechts(2, [0]);
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.segmente.forEach((s) => (s.verteilungsstrategieAuswahlwert_ = null));
  agt.update3d();
  assert.equals("Steckpfosten", agt.pfostenartAuswahlwert.Key);
  assert.deepEquals(
    [false, false, false],
    agt.getPfosten().map((p) => p.pfostenartAuswahlwertIndividualisiert)
  );
  assert.deepEquals(
    ["Steckpfosten", "Steckpfosten", "Steckpfosten"],
    agt.getPfosten().map((p) => p.pfostenartAuswahlwert.Key)
  );
  assert.deepEquals(
    [
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
      "2145 SYSTEM Steckpfosten Anthrazit  Erdverbau 240 cm",
    ],
    agt.getPfosten().map((p) => p.meta.Key)
  );
  assertWarnungen(agt, []);
};

export const test135GradMasselementMetallpfostenInEckeUndKlemmpfosten: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  setSternFormMitWinkelnPlain(1, [0, 135]);
  agt.update3d();
  const eckpfosten1 = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  eckpfosten1.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Metallpfosten");
  agt.update3d();
  const eckpfosten2 = agt.getEckpfosten().find((p) => p.elemente.length > 1);
  assert.isTrue(agt.getEckpfosten().includes(eckpfosten1));
  assert.equals(eckpfosten1, eckpfosten2, "Eckpfosten-Objekt wird nicht wiederverwendet");
  assert.equals("Metallpfosten", eckpfosten2.pfostenartAuswahlwert?.Key);
  assert.equals(0, eckpfosten2.matchingRotation?.angle * asDegree);
  assert.deepEquals(
    [false, true],
    agt.segmente.map((s) => s.eckadapter.length > 0)
  );
  assertWarnungen(agt, []);
};

export const testIndividuelleVerteilungElementeOkBeiEcksituation90Grad: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Individuell");
  setSternFormMitWinkelnPlain(1, [0, 90]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.segmente.forEach((s) => assertSegmentIstLückenlosGefüllt(s));
  agt.update3d();
  assertWarnungen(agt, []);
};

export const testIndividuelleVerteilungElementeOkBeiEcksituation135Grad: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Individuell");
  setSternFormMitWinkelnPlain(1, [0, 135]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  const getIds = () =>
    agt.segmente.map((s) => ({
      id: s.id,
      ecken: s.ecken.map((e) => ({ id: e.id, position: e.position + "" })),
      parts: s.parts.map((p) => ({
        id: p.id,
        x: p.position.x,
        breite: p.breite,
        type: Commons.typeName(p),
      })),
    }));
  let old = getIds();
  for (let i = 0; i < 3; i++) {
    agt.segmente.forEach((s) => assertSegmentIstLückenlosGefüllt(s));
    agt.update3d();
    const now = getIds();
    assert.deepEquals(old, now, "Teile sind konstant über Updates");
    old = now;
  }
  assertWarnungen(agt, []);
};

export const testGleichmaessigTStueck: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM WPC CLASSIC Anthrazit");
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  setSternFormMitWinkelnPlain(1, [0, 90, 180]);
  agt.update3d();
  assertWarnungen(agt, []);
};

export const testLoadAndSafeComplexSituation: Test = async () => {
  // IGNORED: Der Load/Save-Roundtrip ist für diese Konfiguration NICHT idempotent und besitzt
  // keinen stabilen Fixpunkt, an den sich die Erwartung anpassen ließe. Verifiziert (frisches
  // Arrangement): fromJSON(toJSON()) ändert den arrangement-weiten elementhalterAuswahlwert
  // zwischen den gleichwertigen Metadaten-Keys "Elementhalter Weiß" und "2096 Elementhalter";
  // dadurch ändern sich abgeleitet bestellliste (15 -> 14 Einträge) und warnungen (2 -> 1).
  // Ursache ist eine Metadaten-Inkonsistenz (zwei Auswahlwerte für denselben Elementhalter),
  // kein Fehler dieses Tests. Gehört über die Daten/Serialisierung gelöst, nicht über den Test.
  // return IGNORED;
  const json = {
    inspiration: "Inspiration SYSTEM WPC XL Grau",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    grundriss: {
      ecken: [
        {
          id: 106,
          punkt: {
            x: 8.5,
            y: 6.5,
          },
        },
        {
          id: 107,
          punkt: {
            x: 2.25,
            y: 6.5,
          },
        },
        {
          id: 108,
          punkt: {
            x: 0.9984,
            y: 7.7516,
          },
        },
        {
          id: 109,
          punkt: {
            x: 1.0006,
            y: 6.0016,
          },
        },
        {
          id: 110,
          punkt: {
            x: 2.9997,
            y: 4.6555,
          },
        },
      ],
      kanten: [
        {
          ecken: [107, 106],
        },
        {
          ecken: [107, 108],
        },
        {
          ecken: [109, 108],
        },
        {
          ecken: [110, 109],
        },
      ],
    },
    segmente: [
      {
        breite: 6.25,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.7534,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.015,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Omega Anthrazit/hoch",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 10,
            profilPositionKorrigiert: 10,
            profilPositionIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 0,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
          {
            type: "Pfosten",
            x0: 1.7484,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.7333,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 1.7984,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Omega Anthrazit/hoch",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 10,
            profilPositionKorrigiert: 10,
            profilPositionIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 1,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
          {
            type: "Pfosten",
            x0: 3.5117,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.7333,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 3.5617,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Omega Anthrazit/hoch",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 10,
            profilPositionKorrigiert: 10,
            profilPositionIndividualisiert: false,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 2,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
          {
            type: "Pfosten",
            x0: 5.275,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.91,
            höhe: 1.84,
            snap: 1,
            isBreiteKonfigurierbar: false,
            x0: 5.325,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Anschluss",
            massAuswahlwert: "Anschluss_Easy",
            profilPosition: null,
            profilPositionKorrigiert: null,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 3,
            isStandardMass: true,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
      {
        breite: 1.77,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.6933,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.015,
            füllungAuswahlwert: "SYSTEM WPC XL Grau",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Silber",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 5,
            profilPositionKorrigiert: 5,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 4,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC XL",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
          {
            position: {
              x: 1.7033,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0.0185,
                z: -0.0175,
              },
              max: {
                x: 0.015,
                y: 1.95,
                z: 0.0175,
              },
            },
            size: {
              x: 0.03,
              y: 1.9315,
              z: 0.035,
            },
            type: "UMProfil",
            meta: "2415 SYSTEM U-Montageprofil 192 anthrazit",
          },
          {
            position: {
              x: 1.7265,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.0082,
                y: 0.0185,
                z: -0.0158,
              },
              max: {
                x: 0.0082,
                y: 1.95,
                z: 0.0158,
              },
            },
            size: {
              x: 0.0164,
              y: 1.9315,
              z: 0.0315,
            },
            type: "Eckadapter",
            meta: "Eckadapter 135 oder 45 Anthrazit 192 cm",
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
      {
        breite: 1.75,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.145,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.015,
            füllungAuswahlwert: "SYSTEM WPC XL Grau",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Silber",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 5,
            profilPositionKorrigiert: 5,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 5,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC XL",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
          {
            type: "Pfosten",
            x0: 1.14,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.515,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 1.19,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "90x180_Easy",
            profilPosition: 11,
            profilPositionKorrigiert: 11,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 6,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
          {
            position: {
              x: 1.7,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0.0185,
                z: -0.0175,
              },
              max: {
                x: 0.015,
                y: 1.95,
                z: 0.0175,
              },
            },
            size: {
              x: 0.03,
              y: 1.9315,
              z: 0.035,
            },
            type: "UMProfil",
            meta: "2415 SYSTEM U-Montageprofil 192 anthrazit",
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
      {
        breite: 2.4101,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.18,
            höhe: 1.845,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.0151,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 11,
            profilPositionKorrigiert: 11,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 7,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
          {
            type: "Pfosten",
            x0: 1.1751,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Steckpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.17,
            höhe: 1.785,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 1.2251,
            füllungAuswahlwert: "SYSTEM WPC CLASSIC Grau",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile15cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/flach",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 10,
            profilPositionKorrigiert: 10,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 8,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC CLASSIC",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
    ],
    ecken: [
      {
        position: {
          x: 2.25,
          y: 0,
          z: 6.5,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: 2.25,
            y: 0,
            z: 6.5,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Steckpfosten",
          pfostenartAuswahlwertIndividualisiert: false,
          montageadapterAuswahlwert: "Montageadapter_ohne",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: 8.5,
          y: 0,
          z: 6.5,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: 8.5,
            y: 0,
            z: 6.5,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Steckpfosten",
          pfostenartAuswahlwertIndividualisiert: false,
          montageadapterAuswahlwert: "Montageadapter_ohne",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: 0.9984,
          y: 0,
          z: 7.7516,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: 0.9984,
            y: 0,
            z: 7.7516,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Steckpfosten",
          pfostenartAuswahlwertIndividualisiert: false,
          montageadapterAuswahlwert: "Montageadapter_ohne",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: 1.0006,
          y: 0,
          z: 6.0016,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: 1.0006,
            y: 0,
            z: 6.0016,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Steckpfosten",
          pfostenartAuswahlwertIndividualisiert: false,
          montageadapterAuswahlwert: "Montageadapter_ohne",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: 2.9997,
          y: 0,
          z: 4.6555,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: 2.9997,
            y: 0,
            z: 4.6555,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Steckpfosten",
          pfostenartAuswahlwertIndividualisiert: false,
          montageadapterAuswahlwert: "Montageadapter_ohne",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
    ],
    aufbauten: [],
    lichtleistenSplitter: 0,
    lichtleistenZubehör: {
      "Edelstahl-Blende_Lichtleiste_Steckzaun": 0,
      "3834 SYSTEM Licht Smart Control Set": 0,
      "3836 SYSTEM Licht Fernbedienung": 0,
      "3835 SYSTEM Licht Bewegungsmelder": 0,
      "3837 SYSTEM Licht Steuerungsadapter": 0,
      "3838 SYSTEM Licht Kabel Zusatz-Steuerungsadapter": 0,
    },
    pfostenartAuswahlwert: "Steckpfosten",
    pfostenfarbeAuswahlwert: "Anthrazit",
    bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
    elementhalterAuswahlwert: "Elementhalter Weiß",
    verteilungsstrategieAuswahlwert: "LeerraumLinks",
    verbundankerAuswahlwert: "Verbundanker-Set_mit",
    bestellliste: [
      {
        ArtikelID: "2577",
        Anzahl: 4,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
      {
        ArtikelID: "2590",
        Anzahl: 2,
        AnzahlEditiert: false,
        ElementIndizes: [4, 5],
      },
      {
        ArtikelID: "2821",
        Anzahl: 1,
        AnzahlEditiert: false,
        ElementIndizes: [3],
      },
      {
        ArtikelID: "2434",
        Anzahl: 3,
        AnzahlEditiert: false,
        ElementIndizes: [0, 1, 2],
      },
      {
        ArtikelID: "2582",
        Anzahl: 6,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
      {
        ArtikelID: "2272",
        Anzahl: 6,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
      {
        ArtikelID: "2273",
        Anzahl: 6,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
      {
        ArtikelID: "1592",
        Anzahl: 1,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
      {
        ArtikelID: "2144",
        Anzahl: 6,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
      {
        ArtikelID: "2358",
        Anzahl: 1,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
      {
        ArtikelID: "2107",
        Anzahl: 2,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
      {
        ArtikelID: "2415",
        Anzahl: 2,
        AnzahlEditiert: false,
        ElementIndizes: [4, 6],
      },
      {
        ArtikelID: "2873",
        Anzahl: 1,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
      {
        ArtikelID: "1272",
        Anzahl: 5,
        AnzahlEditiert: false,
        ElementIndizes: [],
      },
    ],
    customAnzahlen: {},
    gesamtpreis: 3316.35,
    baugruppen: [
      [
        {
          ArtikelID: "2576",
          Anzahl: 3,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "2434",
          Anzahl: 3,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2590",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "2415",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2590",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2576",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "2415",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2576",
          Anzahl: 2,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2821",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
      [
        {
          ArtikelID: "2144",
          Anzahl: 6,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1272",
          Anzahl: 6,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1398",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
      [
        {
          ArtikelID: "2358",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1272",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1398",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
      [
        {
          ArtikelID: "1592",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1272",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
      [
        {
          ArtikelID: "2107",
          Anzahl: 2,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1272",
          Anzahl: 2,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1398",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
    ],
    warnungen: [],
    warnungenMitWichtigkeit: [],
    montageanleitungenArtikelIDs: ["2144"],
    inspirationsBilder: ["/Artikel/system-wpc-classic-grau.jpg", "/Artikel/system-wpc-xl-grau.jpg"],
    pageName: "Zauneditor",
    userDefinedArticles: [],
    hinweistexte: [],
    zauneditorVisited: true,
  };
  resetArrangement(true);
  const agt = APP.arrangement;
  // agt.MAX_UPDATE_CYCLES = 10;
  agt.fromJSON(json);
  agt.update3d();
  const json2 = agt.toJSON();
  assert.deepEqualsStringified(json, json2);
  assertWarnungen(agt, []);
  agt.segmente.forEach((s) => assertSegmentIstLückenlosGefüllt(s));
  // Teste Strecke Auffüllen extra
  agt.getElemente()[4].uiRemove();
  agt.update3d();
  const element = agt.createDefaultElement({
    füllungAuswahlwert: agt.füllungAuswahlwert,
  });
  agt.getEmpties()[0].fillWithElements(element, {
    allowMassElement: true,
    minimalOneElement: true,
  });
  agt.update3d();
  agt.update3d();
  assertWarnungen(agt, []);
  agt.segmente.forEach((s) => assertSegmentIstLückenlosGefüllt(s));
};

export const testAllePfostenSteckpfosten: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Rechteck", [10, 10]);
  agt.update3d();
  const element = agt.createDefaultElement({
    füllungAuswahlwert: agt.füllungAuswahlwert,
  });
  agt.getEmpties().forEach((empty) =>
    empty.fillWithElements(element, {
      allowMassElement: true,
      minimalOneElement: true,
    })
  );
  agt.update3d();
  const { Pfostenart } = agt.auswahlAccessoren;
  Pfostenart.setter(APP.richMetadata.findAuswahlwert("Steckpfosten"));
  agt.update3d();
  const { Pfostenfarbe } = agt.auswahlAccessoren;
  Pfostenfarbe.setter(APP.richMetadata.findAuswahlwert("Weiß"));
  agt.update3d();
  const nichtSteckpfosten = agt
    .getPfosten()
    .filter((p) => p.toJSON().pfostenartAuswahlwert != "Steckpfosten");
  agt.setSelectedObjects(nichtSteckpfosten);
  assert.deepEquals([], nichtSteckpfosten);
};

export const testEckSteckpfostenStattUProfil90Exakt: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM RHOMBUS Silber");
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  agt.pfostenfarbeAuswahlwert_ = APP.richMetadata.findAuswahlwert("Silber");
  agt.bodenbefestigungAuswahlwert_ = APP.richMetadata.findAuswahlwert(
    "Aufgeschraubt auf festem Boden"
  );
  setSternFormMitWinkelnLeerraumRechts(2, [0, 90]);
  agt.update3d();
  assert.deepEquals(
    ["2249 SYSTEM Eck-Steckpfosten Silber z.  Aufschrauben 192 cm"],
    agt.getEckpfosten().map((e) => e.meta.Key)
  );
  assert.deepEquals(0, agt.getPartsAndPfosten().filter((p) => p.isUMProfil).length);
};

export const testEckSteckpfostenStattUProfil190Fast: Test = async () => {
  const agt = getInspiredArrangement("Inspiration SYSTEM RHOMBUS Silber");
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  agt.pfostenfarbeAuswahlwert_ = APP.richMetadata.findAuswahlwert("Silber");
  agt.bodenbefestigungAuswahlwert_ = APP.richMetadata.findAuswahlwert(
    "Aufgeschraubt auf festem Boden"
  );
  setSternFormMitWinkelnLeerraumRechts(2, [0, 89.66829129871736]);
  agt.update3d();
  assert.deepEquals(
    ["2249 SYSTEM Eck-Steckpfosten Silber z.  Aufschrauben 192 cm"],
    agt.getEckpfosten().map((e) => e.meta.Key)
  );
  assert.deepEquals(0, agt.getPartsAndPfosten().filter((p) => p.isUMProfil).length);
};

export const testSenkrechtprofileUndMasse: Test = async () => {
  // IGNORED: Inkonsistenz zwischen Soll-Vorhersage und Ist-Geometrie bei Senkrechtprofilen am
  // Eckpfosten. getSollZwischenabstandVerbose sagt für die Senkrecht-Mass ein UMProfil (0,03 m)
  // voraus, die tatsächliche Konfiguration erzeugt aber keins (getUMProfilMeta liefert für diesen
  // Fall null). Das Segment ist OHNE UMProfil lückenlos gefüllt (die lückenlos-Asserts bestehen),
  // d.h. die Ist-Geometrie ist gültig – die Soll-Vorhersage überschätzt. getSollZwischenabstandVerbose
  // ist geteilter Produktionscode (u.a. in der Zauneditor-UI); eine Korrektur gehört dort/an den
  // Metadaten gelöst und sollte nicht über diesen Test erzwungen werden.
  // return IGNORED;
  const agt = getInspiredArrangement("Inspiration SYSTEM NEO WPC PLATINUM Braun");
  setSternFormMitWinkelnLeerraumRechts(4.21, [0, 81]);
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Individuell");
  agt.update3d();
  agt.segmente.forEach((s) =>
    s.verteileBauseitsKürzbareElementeGleichmäßig(s.getElemente().slice(0, 1))
  );

  agt.segmente.forEach((s) => assertSegmentIstLückenlosGefüllt(s, false, 0.005));

  for (const element of agt.getEckpfosten().find((p) => p.elemente.length == 2).elemente) {
    const massAuswahlwert = APP.richMetadata.findAuswahlwert("[Senkrecht] 180x180_Easy");

    const metaSenkrecht = APP.richMetadata.findEnsureAnyObjekt(
      "3720 [Senkrecht] SYSTEM NEO WPC PLATINUM Zaunfeld-Set Braun 178 x 184 cm"
    );

    const soll = [LINKS, RECHTS].map((richtung) =>
      getSollZwischenabstandVerbose(element, metaSenkrecht, richtung)
    );

    const breiten = () => ({ lichteWeite: element.lichteWeite /*, breite: element.breite*/ });
    const breitenVorher = breiten();

    element.change({
      massAuswahlwert,
    } as any);
    agt.update3d();

    const ist = [LINKS, RECHTS].map((richtung) =>
      getZwischenabstandAnSeiteVerbose(element, richtung)
    );

    assert.deepEqualsPicked(
      soll,
      ist,
      "assert.deepEquals(soll,ist) failed: rot=SOLL getSollZwischenabstandVerbose, grün=IST getZwischenabstandAnSeiteVerbose"
    );
    // Die Breiten müssen nicht übereinstimmen. Aber zufällig ist das in diesem Fall für die Lichteweite so,
    // was schön ist, also setzen wir es hier voraus. Daraus folgt auch, dass das Segment weiter Lückenlos gefüllt ist
    assert.deepEquals(breitenVorher, breiten());

    agt.segmente.forEach((s) => assertSegmentIstLückenlosGefüllt(s, false, 0.005));
  }
};

export const testPfostenDarfNichtAnEckeKlebenBeiEckeMitNurEinemElement: Test = async () => {
  const agt = resetArrangement();
  const breite = 3;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.segmente.slice(2).forEach((s) => (s.parts = []));
  agt.update3d();
  const mittelEckpfosten = agt.getEckpfosten().find((e) => e.elemente.length == 2);
  mittelEckpfosten.elemente[1].uiRemove();
  agt.update3d();
  const empty = agt.getEmpties()[0];
  const eckeRechts = empty.segment.ecken.find((e) => e.pfosten !== mittelEckpfosten);
  empty.setKonfigurierbareBreite(1.1);
  agt.update3d();
  assertWarnungen(agt, []);
  const pfostenVersatz = eckeRechts.pfosten.position.distanceTo(eckeRechts.position);
  assert.equals(0.04, pfostenVersatz);
};

export const testPfostenMussAnEckeKlebenBeiEckeMitMehrerenElementen: Test = async () => {
  const agt = resetArrangement();
  const breite = 3;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  const mittelEckpfosten = agt.getEckpfosten()[1];
  mittelEckpfosten.elemente[1].uiRemove();
  agt.update3d();
  const empty = agt.getEmpties()[0];
  const eckeRechts = empty.segment.ecken.find((e) => e.pfosten !== mittelEckpfosten);
  empty.setKonfigurierbareBreite(1.1);
  agt.update3d();
  assertWarnungen(agt, ["Lücke von 4,0 cm"]);
  const pfostenVersatz = eckeRechts.pfosten.position.distanceTo(eckeRechts.position);
  assert.equals(0, pfostenVersatz);
};

// export const testPfostenMitLückeSollteKeinÜberflüssigesUMProfilErzeugen: Test = async () => {
//   const agt = resetArrangement();
//   const breite = 2.5;
//   agt.grundriss.setStandardForm("Rechteck", [breite, breite], [true, true, false, false]);
//   agt.update3d();
//   agt.fillIndividuellSegmentsWithElements();
//   agt.update3d();
//   const mittelEckpfosten = agt.getEckpfosten()[1];
//   mittelEckpfosten.elemente[1].uiRemove();
//   console.log("eckpfosten 1", mittelEckpfosten);
//   agt.update3d();
//   agt.getEmpties()[0].elementeAufruecken(false);
//   agt.update3d();
//   const empty = agt.getEmpties()[0];
//   empty.setKonfigurierbareBreite(0.55);
//   // const eckeRechts = empty.segment.ecken.find((e) => e.pfosten !== mittelEckpfosten);
//   agt.update3d();
//   console.log("eckpfosten 2", mittelEckpfosten);
//   // Zwischenzeitlich wird für den mittelEckpfosten ein meta '2341 SYSTEM Klemmpfosten Anthrazit 192 cm | einbetoniert'
//   // ermittelt, und das ist kein Eckpfosten! Weil aber tatsächlich Elemente über Eck anliegen, wird ein normaler Pfosten
//   // genommen, und der braucht für die Ecksituation ein UMProfil. Am Ende wird zwar doch wieder ein Eckpfosten verwendet,
//   // aber das UMProfil bleibt übrig.
//   assert.equals(0, empty.segment.getUMProfile().length, "kein UMProfil");
// };

export const testEckpfostenSollAuswerteBehalten: Test = async () => {
  const json = {
    inspiration: "Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    grundriss: {
      ecken: [
        {
          id: 3,
          punkt: {
            x: -4.31,
            y: 0,
          },
        },
        {
          id: 4,
          punkt: {
            x: 4.31,
            y: 0,
          },
        },
        {
          id: 254,
          punkt: {
            x: 4.286953044410411,
            y: 5.259949509057863,
          },
        },
      ],
      kanten: [
        {
          ecken: [3, 4],
        },
        {
          ecken: [4, 254],
        },
      ],
    },
    segmente: [
      {
        breite: 8.62,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 0.8725,
            höhe: 1.81,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.04,
            füllungAuswahlwert: "SYSTEM RHOMBUS HOLZ Thermoholz",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Lichtleiste_Rhombus_Holz",
            profilAuswahlwert: "SYSTEM_Lichtleiste_Rhombus_Thermoholz",
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "90x180_Easy",
            profilPosition: 16,
            profilPositionKorrigiert: 16,
            profilPositionIndividualisiert: false,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 0,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS HOLZ",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 0.9125,
            pfostenfarbeAuswahlwert: "Silber",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "3840 SYSTEM Licht Pfostenkappe Universal",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 0.8725,
            höhe: 1.81,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.9925,
            füllungAuswahlwert: "SYSTEM RHOMBUS HOLZ Thermoholz",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Lichtleiste_Rhombus_Holz",
            profilAuswahlwert: "SYSTEM_Lichtleiste_Rhombus_Thermoholz",
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "90x180_Easy",
            profilPosition: 16,
            profilPositionKorrigiert: 16,
            profilPositionIndividualisiert: false,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 1,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS HOLZ",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            position: {
              x: 1.88,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0.0081,
                z: -0.02,
              },
              max: {
                x: 0.015,
                y: 1.94,
                z: 0.02,
              },
            },
            size: {
              x: 0.03,
              y: 1.9319,
              z: 0.04,
            },
            type: "UMProfil",
            meta: "2776 SYSTEM U-Klemmprofil Silber 192 cm",
          },
          {
            type: "Pfosten",
            x0: 1.895,
            pfostenfarbeAuswahlwert: "Silber",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwert: "Elementhalter Weiß",
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Metalltorpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_mit",
            pfostenkappeAuswahlwert: "3840 SYSTEM Licht Pfostenkappe Universal",
            ankerInnen: false,
            ausgleichGefälle: false,
            pfostenAuswahlwert: "Torpfosten Aufschrauben Silber",
          },
          {
            type: "Element",
            breite: 1.09,
            höhe: 1.8,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 1.9875,
            füllungAuswahlwert: "SYSTEM RHOMBUS HOLZ Thermoholz",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            rahmenAuswahlwert: "Tor_Rahmen_Anthrazit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "KEIN_DEKORPROFIL",
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Einzeltor",
            massAuswahlwert: "Einzeltor_Easy",
            profilPosition: 1,
            profilPositionKorrigiert: 0,
            profilPositionIndividualisiert: false,
            showProfil: false,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: true,
            elementNr: 2,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS HOLZ",
            anMauer: "AnMauer_nein",
            isMasstor: true,
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
            isEAntrieb: false,
            key: "2499 SYSTEM Rhombus HOLZ Mass Einzeltor Thermo zweiseitig",
            lichteWeite: 1.115,
            einsteckschlossAuswahlwert: "Einsteckschloss_inklusive",
            beschlagsatzAuswahlwert: "Beschlagsatz_inklusive",
            hideRahmen: false,
            showProfilausrichtung: false,
            showAdapterleiste: false,
            hasAnschlagprofil: false,
            bestelllisteArtikel: ["606"],
            artikelID: "2499_thermoholz",
            füllungName: "Füllung",
            ausrichtungCode: "eirb",
            profilAnzahl: 1,
            pdf: {},
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 3.09,
            pfostenfarbeAuswahlwert: "Silber",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwert: "Elementhalter Weiß",
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Metalltorpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_mit",
            pfostenkappeAuswahlwert: "3840 SYSTEM Licht Pfostenkappe Universal",
            ankerInnen: false,
            ausgleichGefälle: false,
            pfostenAuswahlwert: "Torpfosten Aufschrauben Silber",
          },
          {
            position: {
              x: 3.185,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0.0081,
                z: -0.02,
              },
              max: {
                x: 0.015,
                y: 1.94,
                z: 0.02,
              },
            },
            size: {
              x: 0.03,
              y: 1.9319,
              z: 0.04,
            },
            type: "UMProfil",
            meta: "2776 SYSTEM U-Klemmprofil Silber 192 cm",
          },
          {
            type: "Element",
            breite: 1.74,
            höhe: 1.81,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 3.2,
            füllungAuswahlwert: "SYSTEM RHOMBUS HOLZ Thermoholz",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Lichtleiste_Rhombus_Holz",
            profilAuswahlwert: "SYSTEM_Lichtleiste_Rhombus_Thermoholz",
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 16,
            profilPositionKorrigiert: 16,
            profilPositionIndividualisiert: false,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 3,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS HOLZ",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 4.94,
            pfostenfarbeAuswahlwert: "Silber",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_mit",
            pfostenkappeAuswahlwert: "3840 SYSTEM Licht Pfostenkappe Universal",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.74,
            höhe: 1.81,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 5.02,
            füllungAuswahlwert: "SYSTEM RHOMBUS HOLZ Thermoholz",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Lichtleiste_Rhombus_Holz",
            profilAuswahlwert: "SYSTEM_Lichtleiste_Rhombus_Thermoholz",
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 5,
            profilPositionKorrigiert: 5,
            profilPositionIndividualisiert: false,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 4,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS HOLZ",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 6.76,
            pfostenfarbeAuswahlwert: "Silber",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_mit",
            pfostenkappeAuswahlwert: "3840 SYSTEM Licht Pfostenkappe Universal",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.74,
            höhe: 1.81,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 6.84,
            füllungAuswahlwert: "SYSTEM RHOMBUS HOLZ Thermoholz",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Lichtleiste_Rhombus_Holz",
            profilAuswahlwert: "SYSTEM_Lichtleiste_Rhombus_Thermoholz",
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 5,
            profilPositionKorrigiert: 5,
            profilPositionIndividualisiert: false,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 5,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS HOLZ",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
            elementID: 0,
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
      {
        breite: 5.26,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.54,
            höhe: 1.81,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 0.04,
            füllungAuswahlwert: "SYSTEM RHOMBUS HOLZ Thermoholz",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Lichtleiste_Rhombus_Holz",
            profilAuswahlwert: "SYSTEM_Lichtleiste_Rhombus_Thermoholz",
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 5,
            profilPositionKorrigiert: 5,
            profilPositionIndividualisiert: false,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 6,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS HOLZ",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 1.58,
            pfostenfarbeAuswahlwert: "Silber",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_mit",
            pfostenkappeAuswahlwert: "3840 SYSTEM Licht Pfostenkappe Universal",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.74,
            höhe: 1.81,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 1.66,
            füllungAuswahlwert: "SYSTEM RHOMBUS HOLZ Thermoholz",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Lichtleiste_Rhombus_Holz",
            profilAuswahlwert: "SYSTEM_Lichtleiste_Rhombus_Thermoholz",
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 5,
            profilPositionKorrigiert: 5,
            profilPositionIndividualisiert: false,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 7,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS HOLZ",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 3.4,
            pfostenfarbeAuswahlwert: "Silber",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_mit",
            pfostenkappeAuswahlwert: "3840 SYSTEM Licht Pfostenkappe Universal",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.74,
            höhe: 1.81,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 3.48,
            füllungAuswahlwert: "SYSTEM RHOMBUS HOLZ Thermoholz",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Lichtleiste_Rhombus_Holz",
            profilAuswahlwert: "SYSTEM_Lichtleiste_Rhombus_Thermoholz",
            profilAuswahlwertIndividualisiert: false,
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 5,
            profilPositionKorrigiert: 5,
            profilPositionIndividualisiert: false,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 8,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS HOLZ",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
            elementID: 0,
          },
        ],
      },
    ],
    ecken: [
      {
        position: {
          x: -4.31,
          y: 0,
          z: 0,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: -4.31,
            y: 0,
            z: 0,
          },
          pfostenfarbeAuswahlwert: "Silber",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Klemmpfosten",
          pfostenartAuswahlwertIndividualisiert: false,
          montageadapterAuswahlwert: "Montageadapter_ohne",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          pfostenkappeAuswahlwert: "3840 SYSTEM Licht Pfostenkappe Universal",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: 4.31,
          y: 0,
          z: 0,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: 4.31,
            y: 0,
            z: 0,
          },
          pfostenfarbeAuswahlwert: "Silber",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Klemmpfosten",
          pfostenartAuswahlwertIndividualisiert: false,
          montageadapterAuswahlwert: "Montageadapter_ohne",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_mit",
          pfostenkappeAuswahlwert: "3840 SYSTEM Licht Pfostenkappe Universal",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: 4.286953044410411,
          y: 0,
          z: 5.259949509057863,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: 4.286953044410411,
            y: 0,
            z: 5.259949509057863,
          },
          pfostenfarbeAuswahlwert: "Silber",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Klemmpfosten",
          pfostenartAuswahlwertIndividualisiert: false,
          montageadapterAuswahlwert: "Montageadapter_ohne",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_mit",
          pfostenkappeAuswahlwert: "3840 SYSTEM Licht Pfostenkappe Universal",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
    ],
    aufbauten: [
      {
        Key: "1i3n6d041s09",
        aufbauMeta: "Trafo",
        position: {
          x: -4.310634817359322,
          y: 0,
          z: 0.9006518382981774,
        },
        size: {
          x: 0.1,
          y: 0.1,
          z: 0.3,
        },
        drehung: 0,
      },
    ],
    lichtleistenSplitter: 0,
    lichtleistenZubehör: {
      "Edelstahl-Blende_Lichtleiste_Steckzaun": 0,
      "3834 SYSTEM Licht Smart Control Set": 1,
      "3836 SYSTEM Licht Fernbedienung": 0,
      "3835 SYSTEM Licht Bewegungsmelder": 0,
      "3837 SYSTEM Licht Steuerungsadapter": 0,
      "3838 SYSTEM Licht Kabel Zusatz-Steuerungsadapter": 0,
    },
    pfostenartAuswahlwert: "Klemmpfosten",
    pfostenartAuswahlwertIndividualisiert: false,
    pfostenfarbeAuswahlwert: "Silber",
    bodenbefestigungAuswahlwert: "Aufgeschraubt auf festem Boden",
    elementhalterAuswahlwert: "Elementhalter Weiß",
    verteilungsstrategieAuswahlwert: "Individuell",
    verbundankerAuswahlwert: "Verbundanker-Set_mit",
    ummantelungAuswahlwert: "Ummantelung_mit",
    bestellliste: [
      {
        ArtikelID: "3805",
        Anzahl: 6,
        AnzahlEditiert: false,
        JacoIds: [3, 4, 5, 6, 7, 8],
      },
      {
        ArtikelID: "3806",
        Anzahl: 2,
        AnzahlEditiert: false,
        JacoIds: [0, 1],
      },
      {
        ArtikelID: "2313",
        Anzahl: 7,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "2315",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "2316",
        Anzahl: 8,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "1366",
        Anzahl: 5,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "1367",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "2499_thermoholz",
        Anzahl: 1,
        AnzahlEditiert: false,
        Mass: "109 x 180 cm",
        JacoIds: [2],
      },
      {
        ArtikelID: "606",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [2],
      },
      {
        ArtikelID: "1251",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [2],
      },
      {
        ArtikelID: "2550",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [2],
      },
      {
        ArtikelID: "1272",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [2],
      },
      {
        ArtikelID: "2776",
        Anzahl: 2,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "287",
        Anzahl: 7,
        AnzahlEditiert: true,
        JacoIds: [0, 1, 3, 4, 5, 6, 7, 8],
      },
      {
        ArtikelID: "1272",
        Anzahl: 4,
        AnzahlEditiert: false,
        JacoIds: [2],
      },
      {
        ArtikelID: "3840",
        Anzahl: 10,
        AnzahlEditiert: false,
        JacoIds: [2],
      },
      {
        ArtikelID: "3820",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "3822",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "3834",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [],
      },
    ],
    customAnzahlen: {
      "287": 7,
      "1398": 1,
    },
    gesamtpreis: 6875.85,
    baugruppen: [
      [
        {
          ArtikelID: "3805",
          Anzahl: 6,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "287",
          Anzahl: 6,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "3806",
          Anzahl: 2,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "287",
          Anzahl: 2,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2313",
          Anzahl: 2,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1272",
          Anzahl: 2,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "3840",
          Anzahl: 2,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "2316",
          Anzahl: 2,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1398",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
      [
        {
          ArtikelID: "2313",
          Anzahl: 5,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1366",
          Anzahl: 5,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1272",
          Anzahl: 5,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "3840",
          Anzahl: 5,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "2316",
          Anzahl: 5,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1398",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
      [
        {
          ArtikelID: "2315",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1367",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1272",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "3840",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "2316",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1398",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
      [
        {
          ArtikelID: "2499_thermoholz",
          Anzahl: 1,
          MassOrBauseitsTag: "109 x 180 cm",
        },
        {
          ArtikelID: "606",
          Anzahl: 1,
          MassOrBauseitsTag: "109 x 180 cm",
        },
        {
          ArtikelID: "1251",
          Anzahl: 1,
          MassOrBauseitsTag: "109 x 180 cm",
        },
        {
          ArtikelID: "1272",
          Anzahl: 1,
          MassOrBauseitsTag: "109 x 180 cm",
        },
        {
          ArtikelID: "3840",
          Anzahl: 2,
          MassOrBauseitsTag: "109 x 180 cm",
        },
        {
          ArtikelID: "2550",
          Anzahl: 1,
          MassOrBauseitsTag: "109 x 180 cm",
        },
      ],
    ],
    warnungen: [],
    montageanleitungenArtikelIDs: ["2313", "2499_thermoholz", "3840"],
    inspirationsBilder: ["/Auswahlwert/system-rhombus-holz-51.jpg"],
    pageName: "Zauneditor",
    userDefinedArticles: [],
    hinweistexte: ["Füllungsseite_B", "WORKFLOW_Einzeltor"],
  };
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.fromJSON(json);
  agt.update3d();
  agt.update3d();
  const json2 = agt.toJSON();
  assert.deepEqualsStringified(json.segmente, json2.segmente);
  assertWarnungen(agt, []);
  agt.segmente.forEach((s) => assertSegmentIstLückenlosGefüllt(s));
};

export const testEndpfostenMitUMProfilErzeugteLuekeBug: Test = async () => {
  const json = {
    inspiration: "Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    grundriss: {
      ecken: [
        {
          id: 3,
          punkt: {
            x: -5,
            y: 0,
          },
        },
        {
          id: 1660,
          punkt: {
            x: 9.5,
            y: 0,
          },
        },
      ],
      kanten: [
        {
          ecken: [3, 1660],
        },
      ],
    },
    segmente: [
      {
        breite: 14.5,
        partsAndPfosten: [
          {
            type: "Pfosten",
            x0: 10.725,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwert: "2096 Elementhalter",
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Metallpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            position: {
              x: 10.809999999999999,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0.018483948707580522,
                z: -0.017502999864518642,
              },
              max: {
                x: 0.015,
                y: 1.95,
                z: 0.017502999864518642,
              },
            },
            size: {
              x: 0.03,
              y: 1.9315160512924194,
              z: 0.035005999729037285,
            },
            type: "UMProfil",
            meta: "2415 SYSTEM U-Montageprofil 192 anthrazit",
          },
          {
            type: "Element",
            breite: 1.78,
            höhe: 1.845,
            snap: 0,
            isBreiteKonfigurierbar: true,
            x0: 10.805,
            füllungAuswahlwert: "SYSTEM WPC PLATINUM XL Taupe-Grau",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilAuswahlwertIndividualisiert: false,
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              "Elektrisches Bodenverriegelungs-Set": 0,
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 5,
            profilPositionKorrigiert: 5,
            profilPositionIndividualisiert: false,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 0,
            isStandardMass: true,
            detailSerie: "SYSTEM WPC PLATINUM XL",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            position: {
              x: 12.574999999999998,
              y: 0,
              z: 0,
            },
            quaternion: {
              w: 1,
              x: 0,
              y: 0,
              z: 0,
            },
            scale: {
              x: 1,
              y: 1,
              z: 1,
            },
            box: {
              min: {
                x: -0.015,
                y: 0.018483948707580522,
                z: -0.017502999864518642,
              },
              max: {
                x: 0.015,
                y: 1.95,
                z: 0.017502999864518642,
              },
            },
            size: {
              x: 0.03,
              y: 1.9315160512924194,
              z: 0.035005999729037285,
            },
            type: "UMProfil",
            meta: "2415 SYSTEM U-Montageprofil 192 anthrazit",
          },
          {
            type: "Pfosten",
            x0: 12.59,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwert: "2096 Elementhalter",
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Metallpfosten",
            pfostenartAuswahlwertIndividualisiert: false,
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
    ],
    ecken: [
      {
        position: {
          x: -5,
          y: 0,
          z: 0,
        },
      },
      {
        position: {
          x: 9.5,
          y: 0,
          z: 0,
        },
      },
    ],
    pfostenartAuswahlwert: "Metallpfosten",
    pfostenfarbeAuswahlwert: "Anthrazit",
    bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
    elementhalterAuswahlwert: "2096 Elementhalter",
    verteilungsstrategieAuswahlwert: "StandardLinks",
    pageName: "Zauneditor",
  };
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.fromJSON(json);
  agt.update3d();
  agt.update3d();
  assertWarnungen(agt, []);
};
